import React from 'react';
import { MarginPage } from './MarginPage';

export const TradeMargins: React.FC = () => {
  return <MarginPage type="trade" title="Trade Margins" />;
};

export default TradeMargins;
